module.exports = __webpack_public_path__ + "static/media/novascript_logo.e101de04.png";